import { userRoles } from "./constants";

export const isUserSeller = (user) => (user === null ? false : user.roleId === userRoles.seller);
